import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import {
  SaleModuleService,
} from "../../services/SaleModuleService";
import {
  AuctionModuleService,
} from "../../services/AuctionModuleService";
import { toast } from "react-toastify";
import { NftTokenService } from "../../services/NftTokenService";
import { getContractAddress } from "../../utils/abiHelper";
import { getUserAddress } from "../../web3Helper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SALE_TYPE } from "../../constants";
import { addressZero } from "../../web3Utils";

const ListNftModal = ({ toggle, onCloseModal, tokenId }) => {
  const [price, setPrice] = useState(0);
  const [startTime, setStartTime] = useState(
    parseInt(new Date().getTime()) + 86400
  ); // Need to add date pickers


  const [endTime, setEndTime] = useState(
    parseInt(new Date().getTime()) + 86400
  ); // Need to add date pickers
  const [bidIncrement, setBidIncrement] = useState(0);
  const [highestBindingBid, setHighestBindingBid] = useState(0);

  const [activeTab, setActiveTab] = useState(SALE_TYPE["NORMAL"]);
  const [approvalRequiredFromNft, setApprovalRequiredFromNft] = useState(false);
  const [isMarketItemLoading, setIsMarketItemLoading] = useState(false);
  const [isNftApprovalInProgress, setIsNftApprovalInProgress] = useState(false);
  const [isListingInitInProgress, setIsListingInitInProgress] = useState(false);
  const [isUnListingItemInProgress, setIsUnListingItemInProgress] =
    useState(false);
  const [isListingItemInProgress, setIsListingItemInProgress] =
    React.useState(false);
  const [hasListingInitialised, setHasListingInitialised] =
    React.useState(false);
  const [marketItem, setMarketItem] = useState({});

  let obj = {
    array: [],
  };
  for (var l = 0; l < 20; l++) {
    obj.array[l] = l + 1;
  }
  console.log("obj: ", obj);
  let optionItems = obj.array.map((item) => (
    <option key={item} value={item}>
      {item}
    </option>
  ));
  const handleListingInit = async () => {
    setApprovalRequiredFromNft(false);
    setHasListingInitialised(false);

    const nftTokenService = new NftTokenService();
    const marketPlaceService = activeTab === SALE_TYPE["AUCTION"] ? new AuctionModuleService() : new SaleModuleService();
    const contractAddress = await getContractAddress(
      marketPlaceService.contractType
    );
    const userAddress = await getUserAddress();

    setIsListingInitInProgress(true);
    nftTokenService
      .isApprovedForAll(userAddress, contractAddress)
      .then((isApprovedForAll) => {
        setIsListingInitInProgress(false);
        setApprovalRequiredFromNft(!isApprovedForAll);
        setHasListingInitialised(true);
      })
      .catch((err) => {
        setIsListingInitInProgress(false);
        setHasListingInitialised(false);
        toast.error(err);
      });
  };

  const handleApprovalFromNft = async () => {
    const nftTokenService = new NftTokenService();
    const marketPlaceService = activeTab === SALE_TYPE["AUCTION"] ? new AuctionModuleService() : new SaleModuleService();
    const contractAddress = await getContractAddress(
      marketPlaceService.contractType
    );

    setIsNftApprovalInProgress(true);
    nftTokenService
      .setApprovalForAll(contractAddress, true)
      .then(() => {
        setIsNftApprovalInProgress(false);
        setApprovalRequiredFromNft(false);
      })
      .catch((err) => {
        setIsNftApprovalInProgress(false);
        setApprovalRequiredFromNft(false);
        setHasListingInitialised(false);
        toast.error(err);
      });
  };

  const handleListingItem = async () => {
    const marketPlaceService = activeTab === SALE_TYPE["AUCTION"] ? new AuctionModuleService() : new SaleModuleService();
    let listingMethod = marketPlaceService.listItem;

    const itemData = {
      tokenId,
      startTime: parseInt(startTime / 1000),
      endTime: parseInt(endTime / 1000),
    };

    if (activeTab === SALE_TYPE["AUCTION"]) {
      listingMethod = marketPlaceService.listItem;
      itemData["bidIncrement"] = bidIncrement;
      itemData["highestBindingBid"] = highestBindingBid;
    } else {
      itemData["price"] = price;
    }

    setIsListingItemInProgress(true);
    listingMethod(itemData)
      .then(() => {
        setIsListingItemInProgress(false);
        setHasListingInitialised(false);
        onCloseModal();
        toast.success("Item listed Successfully!");
      })
      .catch((err) => {
        setIsListingItemInProgress(false);
        setHasListingInitialised(false);
        toast.error(err);
      });
  };

  const handleUnlistingItem = async () => {
    const marketPlaceService = marketItem.saleType === SALE_TYPE.AUCTION ? new AuctionModuleService() : new SaleModuleService()

    setIsUnListingItemInProgress(true);
    marketPlaceService
      .unlistItem({
        tokenId,
      })
      .then(() => {
        setIsUnListingItemInProgress(false);
        onCloseModal();
      })
      .catch((err) => {
        setIsUnListingItemInProgress(false);
        toast.error(err);
      });
  };

  React.useEffect(() => {
    init();
  }, [tokenId]);

  const init = () => {
    const auctionModuleService = new AuctionModuleService();
    const saleModuleService = new SaleModuleService();

    setIsMarketItemLoading(true);

    Promise.allSettled([
      saleModuleService.getMarketItem( tokenId ),
      auctionModuleService.getMarketItem( tokenId )
    ]).then(([
      saleMarketItemData,
      auctionMarketItemData
    ]) => {
      setMarketItem(
        auctionMarketItemData.value && auctionMarketItemData.value.owner !== addressZero() ? 
          auctionMarketItemData.value
        : saleMarketItemData.value && saleMarketItemData.value.owner !== addressZero() ? 
          saleMarketItemData.value
        : {}
      )
    })
    .finally(() => setIsMarketItemLoading(false));
  };

  return (
    <Modal
      open={toggle}
      onClose={onCloseModal}
      closeOnOverlayClick={false}
      classNames={{
        overlay: "customOverlay",
        modal: "modal-1",
      }}
      center
    >
      <h5 className="mx-3">List NFT on Marketplace</h5>
      <button
        onClick={onCloseModal}
        className="btn position-absolute top-0 end-0"
      >
        X
      </button>
      <div className="mt-4 mx-5">
        {isMarketItemLoading ? (
          <h5 className="m-auto">Loading... </h5>
        ) : marketItem.saleType === SALE_TYPE["NORMAL"] ||
          marketItem.saleType === SALE_TYPE["AUCTION"] ? (
          <>
            <h5 className="mx-auto mt-auto mb-2">Item Already Listed</h5>
            <button
              className="mx-auto mt-2 mb-auto btn buy"
              onClick={() => handleUnlistingItem()}
              disabled={isUnListingItemInProgress}
            >
              {isUnListingItemInProgress ? "Please Wait!" : "Unlist Item"}
            </button>
          </>
        ) : (
          <>
            <div className="toggle-div my-3">
              <button
                disabled={hasListingInitialised}
                onClick={() => setActiveTab(SALE_TYPE["NORMAL"])}
                className={`${
                  activeTab === SALE_TYPE["NORMAL"] ? "active-btn" : ""
                } inactive btn`}
              >
                FIXED PRICE
              </button>
              <button
                disabled={hasListingInitialised}
                onClick={() => setActiveTab(SALE_TYPE["AUCTION"])}
                className={`${
                  activeTab === SALE_TYPE["AUCTION"] ? "active-btn" : ""
                } inactive btn`}
              >
                TIMED AUCTION
              </button>
            </div>
            <div className="mx-2 mt-2 mb-3">
              {activeTab === SALE_TYPE["NORMAL"] && (
                <>
                  <input
                    className={`form-control w-100 `}
                    onChange={(e) => setPrice(Number(e.target.value))}
                    placeholder="Price"
                  />
                  <div className="d-flex mt-3">
                    {" "}
                    <DatePicker
                      selected={startTime}
                      showTimeSelect
                      className={`form-control ml-2 mb-2`}
                      dateFormat="MMMM d, yyyy h:mm aa"
                      onSelect={(date) => setStartTime(date)}
                      onChange={(date) => setStartTime(date)}
                    />
                    <DatePicker
                      selected={endTime}
                      showTimeSelect
                      dateFormat="MMMM d, yyyy h:mm aa"
                      className={`form-control ml-2 mb-2`}
                      onSelect={(date) => setEndTime(date)}
                      onChange={(date) => setEndTime(date)}
                    />
                  </div>
                </>
              )}
              {activeTab === SALE_TYPE["AUCTION"] && (
                <>
                  <input
                    className={`form-control mb-2 w-100`}
                    onChange={(e) => setBidIncrement(Number(e.target.value))}
                    placeholder="Bid Increment"
                  />
                  {/* <div className="d-flex"> */}
                  <input
                    className={`form-control mb-2 w-100`}
                    onChange={(e) =>
                      setHighestBindingBid(Number(e.target.value))
                    }
                    placeholder="Minimum Bid"
                  />
                  {/* </div> */}
                  <div className="d-flex">
                    {" "}
                    <DatePicker
                      selected={startTime}
                      showTimeSelect
                      className={`form-control ml-2 mb-2`}
                      dateFormat="MMMM d, yyyy h:mm aa"
                      onSelect={(date) => setStartTime(date)}
                      onChange={(date) => setStartTime(date)}
                    />
                    <DatePicker
                      selected={endTime}
                      showTimeSelect
                      dateFormat="MMMM d, yyyy h:mm aa"
                      className={`form-control ml-2 mb-2`}
                      onSelect={(date) => setEndTime(date)}
                      onChange={(date) => setEndTime(date)}
                    />
                  </div>
                </>
              )}
            </div>
            {approvalRequiredFromNft ? (
              <button
                onClick={() => handleApprovalFromNft()}
                className="btn buy"
                disabled={isNftApprovalInProgress}
              >
                {isNftApprovalInProgress ? "Please Wait!" : `Approve`}
              </button>
            ) : hasListingInitialised ? (
              <button
                onClick={() => handleListingItem()}
                className="btn buy"
                disabled={isListingItemInProgress}
              >
                {isListingItemInProgress
                  ? "Please Wait!"
                  : `Confirm Listing Item`}
              </button>
            ) : (
              <button
                onClick={() => handleListingInit()}
                className="btn buy"
                disabled={isListingInitInProgress}
              >
                {isListingInitInProgress ? "Please Wait!" : "List Item"}
              </button>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};
export default ListNftModal;
